import { render, staticRenderFns } from "./factoryIcon.vue?vue&type=template&id=2af8ee84&"
import script from "./factoryIcon.vue?vue&type=script&lang=js&"
export * from "./factoryIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports